/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import PropTypes from 'prop-types';
import 'rc-notification/assets/index.css';
import React, { useRef, Component } from "react";
import moment from 'moment';
import { Row, Col, } from 'reactstrap';
import Select from 'react-select';
import Notification from 'rc-notification';
import { Table, Button, Popconfirm, Upload } from "antd";
import * as XLSX from 'xlsx';
import SmallLoader from '../../../../shared/components/SmallLoader';
import history from '../../../App/History';
import SearchPositionTrackerImportExcelTable from './SearchPositionTrackerImportExcelTable';
import { searchPositionTrackerTableHeader as tableHeaderData } from "../../helper";

class ImportSearchPositionTrackerExcel extends Component {
  constructor(props) {
    super(props);
    this.input = React.createRef();

    const previousMonthDate = new Date();
    previousMonthDate.setMonth(previousMonthDate.getMonth() - 3)
    
    this.tableData = { tableHeaderData: [], tableRowsData: [] };
    this.isEmptyCell = false;
    this.isError = false;
    this.isLoading = false;
    this.errorMessage = '';
    this.cogsNumberCount = 0;
    this.emptyCellCount = 0;
    this.emptyCellErrorMessage = '';
    this.cogsErrorMessage = '';  
    
    this.state = {
      cols: [],
      rows: [],
      regexp: /^\$?[0-9.,]+$/,
      errorMessage: null,
      columns: [
        {
          title: "Title",
          dataIndex: "title",
          editable: true,
          width: 180
        },
        {
          title: "ASIN",
          dataIndex: "asin",
          editable: true,
          width: 300
        },
        {
          title: "Keyword Sales",
          dataIndex: "keywordSales",
          editable: true,
          width: 500
        },
        {
          title: "Keyword",
          dataIndex: "keyword",
          editable: true,
          width: 200
        },
        {
          title: "Marketplace",
          dataIndex: "marketplace",
          editable: true,
          width: 200
        },
        {
          title: "Search Volume",
          dataIndex: "searchVolume",
          editable: true,
          width: 200
        },
        {
          title: "Organic Rank",
          dataIndex: "organicRank",
          editable: true,
          width: 200
        },
        {
          title: "Sponsored Position",
          dataIndex: "sponsoredPosition",
          editable: true,
          width: 200
        },
        {
          title: "Date Added",
          dataIndex: "date",
          editable: true,
          width: 200
        }
      ],
      fromDate: previousMonthDate,
      toDate: new Date(),
      sku: ''
    };
  }

  handleFromDateChange = (date) => {
    this.setState({fromDate: date});
  }

  handleToDateChange = (date) => {
    this.setState({toDate: date});
  }

  handleSave = (row) => {
    const newData = [...this.state.rows];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });
    this.setState({ rows: newData });
  };

  clearData = () => {
    this.setState({ rows: [] })
    this.input.current.value = ""
  }

  // Helper function to convert Excel date serial number to JavaScript Date
  excelDateToJSDate = (serial) => {
    // Excel uses 1900-01-01 as day 1, but JavaScript Date uses 1970-01-01
    // Excel also incorrectly treats 1900 as a leap year
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);
    return date_info;
  }

  onImportExcel = (event) => {
    const { files } = event.target;
    
    if (files.length === 1) {
      const file = files[0];
      
      // Check file type
      if (!(file.type === "application/vnd.ms-excel" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
        || file.type === "text/csv")) {
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Unknown file format!',
            duration: 5,
            closable: true,
            style: { top: 120, fontWeight: "bold" },
            maxCount: 50
          });
        });
        this.setState({
          errorMessage: "Unknown file format!"
        });
        return false;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array', cellDates: true });
          
          // Get the first worksheet
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          
          // Convert to array of arrays (similar to react-excel-renderer format)
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
            header: 1, 
            defval: undefined,
            raw: false
          });

          const newRows = [];
          
          // Skip header row (index 0) and process data rows
          jsonData.slice(1).forEach((row, index) => {
            if (row && row !== "undefined") {
              // Debug logging for specific row
              if(index === 2100){
                console.log("Date:", row[8])
                console.log("Keyword-Formated Date:", 
                String(row[3]), moment(new Date((row[8] - 25569) * 86400 * 1000))
                .format('YYYY-MM-DD'))
                console.log("Formated Date With S:", 
                String(moment(new Date((row[8] - (25567 + 2)) * 86400 * 1000)).format('YYYY-MM-DD')))
                
                const excelStartDate = new Date('1899-12-30T00:00:00Z');
                const dateMilliseconds = excelStartDate.getTime() + row[8] * 24 * 60 * 60 * 1000;
                console.log("Formated Date Mili:", dateMilliseconds);
                const formattedDate = moment(1703971015000).format('YYYY-MM-DD');
                console.log("Formated Date:", formattedDate);
              }

              if (row[0] !== undefined || row[1] !== undefined || row[4] !== undefined) {
                let reportDate = '';
                
                // Handle date formatting
                if (row[8] !== undefined && row[8] !== null) {
                  // Check if it's already a valid date string
                  const isDate = moment(row[8], 'YYYY-MM-DD HH:mm').isValid();
                  if (isDate) {
                    reportDate = moment(row[8]).format('YYYY-MM-DD');
                  } else if (typeof row[8] === 'number') {
                    // Handle Excel serial date number
                    const date = this.excelDateToJSDate(row[8]);
                    reportDate = moment(date).format('YYYY-MM-DD');
                  } else if (row[8] instanceof Date) {
                    // Handle JavaScript Date object
                    reportDate = moment(row[8]).format('YYYY-MM-DD');
                  } else {
                    // Try to parse as date string
                    const parsedDate = moment(row[8]);
                    if (parsedDate.isValid()) {
                      reportDate = parsedDate.format('YYYY-MM-DD');
                    } else {
                      reportDate = '';
                    }
                  }
                }
                
                newRows.push({
                  title: row[0] ? String(row[0]) : '',
                  asin: row[1] ? String(row[1]) : '',
                  keywordSales: row[2] ? String(row[2]) : '',
                  keyword: row[3] ? String(row[3]) : '',
                  marketplace: row[4] ? String(row[4]).replace('www.', '') : '',
                  searchVolume: row[5] ? String(row[5]) : '',
                  organicRank: row[6] ? String(row[6]) : '',                    
                  sponsoredPosition: row[7] ? String(row[7]) : '',
                  date: reportDate,
                });
              }
            }
          });

          if (this.isError === true) {
            this.errorMessage = this.cogsErrorMessage
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: <span>{this.errorMessage}</span>,
                duration: 10,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
                onClick() {
                  console.log('clicked!!!');
                },
                style: { top: 120, fontWeight: "bold" },
              });
            });
          } else {
            this.isError = false;
            this.isEmptyCell = false;
          }

          if (newRows.length === 0) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: { top: 120, fontWeight: "bold" },
                maxCount: 50
              });
            });
          } else {
            this.setState({
              cols: Object.keys(jsonData[0] || {}), // Create cols array from first row keys
              rows: newRows,
              errorMessage: null
            });
          }

        } catch (error) {
          console.error('Error reading Excel file:', error);
          Notification.newInstance({}, (notification) => {
            notification.notice({
              content: 'Error reading Excel file!',
              duration: 5,
              closable: true,
              style: { top: 120, fontWeight: "bold" },
              maxCount: 50
            });
          });
          this.setState({
            errorMessage: "Error reading Excel file!"
          });
        }
      };

      reader.onerror = () => {
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Error reading file!',
            duration: 5,
            closable: true,
            style: { top: 120, fontWeight: "bold" },
            maxCount: 50
          });
        });
      };

      reader.readAsArrayBuffer(file);
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'No file uploaded!',
          duration: 10,
          closable: true,
          style: { top: 120, fontWeight: "bold" },
          maxCount: 50
        });
      });
      this.setState({
        errorMessage: "No file uploaded!"
      });
      return false;
    }
    return false;
  };

  handleSubmit = async () => {
    if(this.state.sku === ''){
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Please select SKU',
          duration: 10,
          style: { fontWeight: "bold" },
          maxCount: 40
        });
      }); 
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Please wait....',
          duration: 10,
          style: { top: 200, fontWeight: "bold" },
          maxCount: 40
        });
      });   

      const finalData = [];
      const specialCharPattern = /[^a-zA-Z0-9\s-]/g;

      this.state.rows.forEach((_item) => {
        finalData.push({
          reportDate: _item.date,
          salesChannel: _item.marketplace,
          asin: _item.asin,
          sku: this.state.sku,
          title: _item.title,
          keywordSales: specialCharPattern.test(_item.keywordSales) ? '0' : _item.keywordSales.replace(/-/g, '0'),
          keyword: _item.keyword,
          searchVolume: specialCharPattern.test(_item.searchVolume) ? '0' : _item.searchVolume.replace(/-/g, '0'),
          organicRank: specialCharPattern.test(_item.organicRank) ? '0' : _item.organicRank.replace(/-/g, '0'),
          sponsoredPosition: specialCharPattern.test(_item.sponsoredPosition) ? '0' : _item.sponsoredPosition.replace(/-/g, '0')
        })
      })
      
      const token = localStorage.getItem('easydev');
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        body: JSON.stringify(finalData)
      };
      
      this.isLoading = true;
      
      try {
        const response = await fetch('https://rss.getrael.com/api/position-tracker/update', requestOptions);
        const data = await response.json();
        
        if (data.code === '200') {
          this.isLoading = false;
          this.setState({ rows: [] })
          this.input.current.value = ""
          Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'Search Position Tracker uploaded successfully.',
                duration: 10,
                closable: true,
                style: {top: 120, fontWeight: "bold"},
                maxCount: 50
              });
            });
          history.push('/report/searchPositionTracker/detail')
        } else if (data.code === '403') {
          this.isLoading = false;
          history.push('/login')
        } else {
          this.isLoading = false;
          Notification.newInstance({}, (notification) => {
            notification.notice({
              content: data.error,
              duration: 10,
              closable: true,          
              style: { top: 120, fontWeight: "bold", color: 'red' },
              maxCount: 50
            });
          });        
        }
      } catch (error) {
        this.isLoading = false;
        console.error('Submit error:', error);
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Error uploading data. Please try again!',
            duration: 10,
            closable: true,          
            style: { top: 120, fontWeight: "bold", color: 'red' },
            maxCount: 50
          });
        });
      }
    }
  };

  handleDelete = (key) => {
    const rows = [...this.state.rows];
    this.setState({ rows: rows.filter(item => item.key !== key) });
  };

  handleAdd = () => {
    const { count, rows } = this.state;
    const newData = {
      key: count,
      name: "User's name",
      age: "22",
      gender: "Female"
    };
    this.setState({
      rows: [newData, ...rows],
      count: count + 1
    });
  };  

  handleSKU = (value) => {
    this.setState({sku: value})
  }

  render() {
    console.log(this.state.rows)
    const { skuOptions } = this.props;
    
    const components = {
      body: {
        //  row: EditableFormRow,
        //  cell: EditableCell
      }
    };
    
    const columns = this.state.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave
        })
      };
    });
    
    return (
      <>
        <Col md={12}>
          <Row>
            <Col md="3" className='pr-0'>
              <div className="form__form-group mb-0">
                <span className="form__form-group-label">SKU</span>
                <div className="form__form-group-field">
                  <Select
                    value={this.sku}
                    options={skuOptions}
                    clearable={false}
                    placeholder="Select"
                    className="sku-select_filter-250"
                    onChange={event => this.handleSKU(event.value)}
                    classNamePrefix="react-select"                                             
                  />                    
                </div>
              </div>
            </Col>            
            <Col md="4">
              <input 
                className="file-uploader" 
                type="file" 
                accept=".xlsx, .xls, .csv" 
                onChange={this.onImportExcel}
                ref={this.input} 
              />
              &nbsp;<Button 
                className="btn btn-sm btn-danger"
                style={{ marginTop: 16 }}
                onClick={this.clearData}
              >
                &nbsp;Clear
              </Button>
            </Col>
            <Col md="5" align="right">
              {this.state.rows.length > 0 && (
                <>
                  <Button
                    onClick={this.handleSubmit}
                    size="large"
                    type="primary"
                    className="btn btn-primary btn-sm"
                    disabled={this.isEmptyCell}
                    style={{ marginBottom: 16, marginLeft: 0, marginTop: 16 }}
                  >
                    Submit
                  </Button>
                </>
              )}
              <Button
                onClick={() => history.push('/report/searchPositionTracker/detail')}
                size="large"
                type="danger"
                className="btn btn-primary btn-sm"
                style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
              >
                Back
              </Button>
            </Col>           
          </Row>
          <Row style={{marginTop: '15px'}}>
            <Col md={12} lg={12}>
              <div className="top-location" style={{ minHeight: '400' }}>
                <div>
                  {this.isLoading ? 
                    <div style={{ minHeight: '200px' }} className="row align-items-center justify-content-center">
                      <SmallLoader loading={this.isLoading} />
                    </div>
                    : 
                    <SearchPositionTrackerImportExcelTable 
                      customClass="pt-0" 
                      reactTableData={{ tableHeaderData }}
                      data={this.state.rows} 
                    />
                  }
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </>
    );
  }
}

ImportSearchPositionTrackerExcel.propTypes = {   
  skuOptions: PropTypes.arrayOf(PropTypes.string),
};

ImportSearchPositionTrackerExcel.defaultProps = {
  skuOptions: [],
};

export default ImportSearchPositionTrackerExcel;